import React from 'react';
import { TextInput, NumberInput, CheckBox } from 'hyperdb-utils';
import {genKey} from '../../../../helpers/gen-key';

const DominoFields = ({ type, settings, onChange, checkboxesToDisplay = [] }) => {
  const handleClickCheckbox = (attributeName) => {
    const checked = !settings[attributeName];
    onChange(attributeName, { value: checked });
  };
  const handleClickUpdateKey = () => {
    onChange('api_key', { value: genKey() });
  }
  const keyLabel = (
    <span>
      API Key
      &nbsp;
      {settings.api_key ? null :
        <button
          type="button"
          className="btn btn-default btn-xs"
          onClick={ handleClickUpdateKey }
        >Generate API Key</button>
      }

    </span>
  );
  return (
    <div>
      { type === 'input' ? null :
        <TextInput
          label="Remote URL"
          name="remote_url"
          value={ settings.remote_url }
          onChange={ onChange.bind(null, 'remote_url') }
        />
      }
      <TextInput
        label={ keyLabel }
        name="api_key"
        value={ settings.api_key }
        onChange={ onChange.bind(null, 'api_key') }
      />
      <NumberInput
        label="Price ratio"
        name="price_ratio"
        value={ settings.price_ratio }
        onChange={ onChange.bind(null, 'price_ratio') }
      />
      <div>
        {
          checkboxesToDisplay.map((checkbox, i) => {
            return (
              <CheckBox
                label={ checkbox }
                name={ checkbox }
                checked={ settings[checkbox] }
                onChange={ handleClickCheckbox.bind(null, checkbox) }
              />
            );
          })
        }
      </div>
    </div>
  );
};

export default DominoFields;



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/channel/components/DominoFields.jsx